import { useContext, useEffect, useMemo } from 'react';
import { InspectionContext } from '../context/InspectionContext';
import { useLazyGetInspectionSampleSizeQuery } from 'app/features/inspection/api';
import { TrackingRequestContext } from 'app/context/tracking-request';

type Params = {
  qty: number;
  inspectionLevel: string;
  inspectionAqlCritical: string | number;
  inspectionAqlMajor: string | number;
  inspectionAqlMinor: string | number;
};

export const useFetchSampleSize = (params: Params) => {
  const { addRequest, removeRequest } = useContext(TrackingRequestContext);
  const context = useContext(InspectionContext);
  const { cachedSampleSize, updateSampleSize } = context;
  const shouldFetchSampleSize = useMemo(() => {
    if (!params) return false;
    return !cachedSampleSize.has(JSON.stringify(params));
  }, [params, cachedSampleSize]);

  const [fetch, result] = useLazyGetInspectionSampleSizeQuery();

  useEffect(() => {
    if (shouldFetchSampleSize) {
      addRequest(`Sample Size - ${JSON.stringify(params)}`);
      fetch(params as any)
        .unwrap()
        .then((res: any) => {
          updateSampleSize(params, res.data?.aql);
        });
      removeRequest(`Sample Size - ${JSON.stringify(params)}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchSampleSize, params]);

  return {
    sampleSize: cachedSampleSize.get(JSON.stringify(params)),
    ...result,
  };
};
